export default function TitleSection (props){
    return(
        <>
        <div className="containerTitle">
            <h2 className="styleTitle" style={{...props.specialStyles}}>{props.title}</h2>
        </div>
        </>
    )
}